import {
  FETCH_ELECTRICITY_SUPPLIER,
  GET_ELECTRICITY_SUPPLIER,
  CREATE_ELECTRICITY_SUPPLIER,
  UPDATE_ELECTRICITY_SUPPLIER,
  DELETE_ELECTRICITY_SUPPLIER,
} from 'actions/electricitySupplier';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  electricitySuppliers: [],
  supplierDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const electricitySupplierReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ELECTRICITY_SUPPLIER.REQUEST:
    case GET_ELECTRICITY_SUPPLIER.REQUEST:
    case CREATE_ELECTRICITY_SUPPLIER.REQUEST:
    case DELETE_ELECTRICITY_SUPPLIER.REQUEST: {
      return { ...state, isLoading: true, supplierDetail: {} };
    }

    case UPDATE_ELECTRICITY_SUPPLIER.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_ELECTRICITY_SUPPLIER.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        electricitySuppliers: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case GET_ELECTRICITY_SUPPLIER.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        supplierDetail: payload,
      };
    }

    case CREATE_ELECTRICITY_SUPPLIER.SUCCESS: {
      toast.success('Supplier added successfully');
      return {
        ...state,
        isLoading: false,
        electricitySuppliers: _.concat(state.electricitySuppliers, payload),
      };
    }

    case UPDATE_ELECTRICITY_SUPPLIER.SUCCESS: {
      toast.success('Supplier updated successfully');
      return {
        ...state,
        electricitySuppliers: state.electricitySuppliers.map((data) => (data.id === payload.id ? payload : data)),
        isLoading: false,
      };
    }

    case DELETE_ELECTRICITY_SUPPLIER.SUCCESS: {
      toast.success('Supplier deleted successfully');
      return {
        ...state,
        isLoading: false,
        electricitySuppliers: state.electricitySuppliers.filter((data) => data.id !== payload),
      };
    }

    case FETCH_ELECTRICITY_SUPPLIER.FAIL:
    case GET_ELECTRICITY_SUPPLIER.FAIL:
    case CREATE_ELECTRICITY_SUPPLIER.FAIL:
    case UPDATE_ELECTRICITY_SUPPLIER.FAIL:
    case DELETE_ELECTRICITY_SUPPLIER.FAIL: {
      return { ...state, isLoading: false };
    }

    default:
      return { ...state };
  }
};
export default electricitySupplierReducer;
